import { Container, Row, Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import PrizeCard from './PrizeCard'
import { useQuery } from 'react-query'
import { getGiftQuery } from 'dataLayer/game'
import { useState } from 'react'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'

function PrizePage() {
	const { t } = useTranslation()
	const [key, setKey] = useState(1)
	const { data: gifts } = useQuery(getGiftQuery())
	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const giftData = (gifts && gifts.filter(it => it.type === 1)) || []
	const giftSecond = (gifts && gifts.filter(it => it.type === 2)) || []
	return (
		<>
			{/* <Container fluid className="shoppage-container prize px-0 py-3">
				<Row className="mb-3">
					<p>{t('prizepage.choose')}</p>
					<h1 className="mt-2">{t('prizepage.title').toUpperCase()}</h1>
				</Row>
				<div className="package-container prizepage">
					{gifts?.length > 0 ? (
						<PrizeCard data={gifts} />
					) : (
						<img src={noDataIcon} alt="No reward is found" />
					)}
				</div>
			</Container> */}
			<Container fluid className="shoppage-container">
				<Row className="mt-4 mb-3">
					<p>{t('prizepage.choose')}</p>
					<h1 className="mt-2">{t('prizepage.title').toUpperCase()}</h1>
				</Row>
				<div className={`package-container prize ${isMobile ? 'mobile' : ''}`}>
					<Tabs
						id="controlled-tab-example"
						activeKey={key}
						onSelect={k => setKey(k)}
						className="mb-4 mt-4 mt-md-0"
					>
						<Tab eventKey={1} title={t('prizepage.data')}>
							<PrizeCard data={giftData} />
						</Tab>
						<Tab eventKey={2} title={t('prizepage.minutes')}>
							<PrizeCard data={giftSecond} />
						</Tab>
					</Tabs>
				</div>
			</Container>
		</>
	)
}

export default PrizePage
